import { c as _c } from "react/compiler-runtime";
import { useEffect } from "react";
import { useIsMutating, useQueryClient } from "react-query";
import { USER_QUERY_KEY, useAuth } from "@/components/AuthProvider";
import { SWITCH_ACTIVE_ORG_MUTATION_KEY, useConnectedGithubOrgsNonSuspense } from "@/hooks/useConnectedGithubOrgs";
import { releasesPageAccess, type ReleasesPageAccess } from "./releasesAccess";

/** Shared by the nav item and the route gate so either one settles access. */
export function useReleasesPageAccess(urlOrg) {
  const $ = _c(13);
  const {
    user
  } = useAuth();
  const {
    connectedGithubOrgs
  } = useConnectedGithubOrgsNonSuspense();
  let t0;
  if ($[0] !== connectedGithubOrgs || $[1] !== urlOrg || $[2] !== user) {
    const urlOrgSelectable = connectedGithubOrgs === undefined || !user ? undefined : user.is_superuser || connectedGithubOrgs.installations.some(installation => installation.account.login === urlOrg);
    t0 = releasesPageAccess({
      user,
      urlOrg,
      urlOrgSelectable
    });
    $[0] = connectedGithubOrgs;
    $[1] = urlOrg;
    $[2] = user;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  const access = t0;
  const orgSwitchPending = useIsMutating(SWITCH_ACTIVE_ORG_MUTATION_KEY) > 0;
  let t1;
  if ($[4] !== access || $[5] !== connectedGithubOrgs?.active_org_name || $[6] !== orgSwitchPending || $[7] !== urlOrg) {
    t1 = access === "pending" && !orgSwitchPending && !!urlOrg && connectedGithubOrgs?.active_org_name?.toLowerCase() === urlOrg.toLowerCase();
    $[4] = access;
    $[5] = connectedGithubOrgs?.active_org_name;
    $[6] = orgSwitchPending;
    $[7] = urlOrg;
    $[8] = t1;
  } else {
    t1 = $[8];
  }
  const userLagsActiveOrg = t1;
  const queryClient = useQueryClient();
  let t2;
  let t3;
  if ($[9] !== queryClient || $[10] !== userLagsActiveOrg) {
    t2 = () => {
      if (userLagsActiveOrg) {
        queryClient.invalidateQueries(USER_QUERY_KEY);
      }
    };
    t3 = [userLagsActiveOrg, queryClient];
    $[9] = queryClient;
    $[10] = userLagsActiveOrg;
    $[11] = t2;
    $[12] = t3;
  } else {
    t2 = $[11];
    t3 = $[12];
  }
  useEffect(t2, t3);
  return access;
}